"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSharedCookbookUserMutationOptions = exports.updateSharedCookbookUserMutation = void 0;
const client_1 = require("@apollo/client");
const updateQuery_1 = require("../../../utils/updateQuery");
const sharedCookbookUsers_1 = require("../queries/sharedCookbookUsers");
exports.updateSharedCookbookUserMutation = client_1.gql `
  mutation UpdateSharedCookbookUser($input: UpdateSharedCookbookUserInput!) {
    updateSharedCookbookUser(input: $input) {
      ok
    }
  }
`;
exports.updateSharedCookbookUserMutationOptions = (variables) => ({
    variables,
    update: store => {
        updateQuery_1.updateQuery(store, sharedCookbookUsers_1.sharedCookbookUsers, x => {
            if (variables.input.permission === "revoke") {
                x.sharedCookbookUsers.users = x.sharedCookbookUsers.users.filter(y => y.user.id !== variables.input.userId);
            }
            else {
                const idx = x.sharedCookbookUsers.users.findIndex(y => y.user.id === variables.input.userId);
                if (idx !== -1) {
                    x.sharedCookbookUsers.users[idx].accessLevel = variables.input
                        .permission;
                }
            }
        }, {
            cookbookId: variables.input.cookbookId,
        });
    },
});
//# sourceMappingURL=updateSharedCookbookUser.js.map